import React, { ReactElement } from "react";
import ThemeMenu from "./ThemeMenu";
import LayoutMenu from "./LayoutMenu";

/**
 * "Your theme" and "Your layout" in the lobby: personal choices, shown only to the player who makes them.
 * Both are drop-downs, so more themes or layouts only add entries to their lists. The two fields are siblings
 * so the lobby can lay them out in a column or side by side.
 */
export default function ThemePicker(props: { onLayoutChange: (round: boolean) => void }): ReactElement {
  return (
    <>
      <div className="theme-picker">
        <div className="lb-field-label">
          Your theme <span className="theme-note">(only you see it)</span>
        </div>
        <ThemeMenu variant="field" />
      </div>
      <div className="theme-picker">
        <div className="lb-field-label">
          Your layout <span className="theme-note">(only you see it)</span>
        </div>
        <LayoutMenu variant="field" onChange={props.onLayoutChange} />
      </div>
    </>
  );
}
